import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

const SlidersContext = React.createContext(null);

const defaultRoute = {
  timesheet: "/",
  quote: "/quotes",
  jobsheet: "/jobsheets",
  restore: "/restores",
};

const SlidersProvider = ({ children }) => {
  const history = useHistory();
  const location = useLocation();
  const [sliders, setSliders] = useState(
    Boolean(window.localStorage.getItem("sliders"))
  );
  const [sliderId, setSliderId] = useState(null);

  // Not sure if I need this. Doesn't seem to be making a difference.
  // useEffect(() => {
  //   setSliders(Boolean(window.localStorage.getItem("sliders")));
  // }, [window.localStorage.getItem("sliders")]);

  function setSliderPrimary(primaryId) {
    // Marked for deletion ****
    if (primaryId) {
      setSliderId(primaryId);
      // window.sessionStorage.setItem("currentPrimary", primaryId);
    } else {
      setSliderId(null);
      // window.sessionStorage.removeItem("currentPrimary");
    }
  }

  const closeSlider = () => {
    // TODO***
    // Issue here with error being thrown when you use the nav bar to navigate too quickly.
    // It will try to set slider state before this component is finished rendering. Not sure
    // how to fix yet.
    setSliderId(null);

    // setCurrentPrimary(null);

    // if (location.pathname.includes("restore")) {
    //   history.replace(defaultRoute.restores);
    // } else
    if (location.state?.timesheet?.primaryType) {
      history.replace(defaultRoute[location.state?.timesheet?.primaryType]);
    }

    // gridRef.current.style.gridTemplateColumns = "1fr 10px 0fr";
  };

  function toggleSliders() {
    if (sliders) {
      // if (location.pathname.includes("restore")) {
      //   history.replace(defaultRoute.restore);
      // } else
      if (location.state?.timesheet?.primaryType) {
        history.replace(defaultRoute[location.state?.timesheet?.primaryType]);
      }

      window.localStorage.removeItem("sliders");
      setSliderId(null);
      setSliders(false);
    } else {
      window.localStorage.setItem("sliders", "true");
      setSliders(true);
    }
  }

  return (
    <SlidersContext.Provider
      value={{
        sliders: sliders,
        toggleSliders: toggleSliders,
        closeSlider,
        sliderId,
        setSliderId,
      }}
    >
      {children}
    </SlidersContext.Provider>
  );
};

export { SlidersProvider, SlidersContext };
